<template>
	<b-card>
		<template #header>
			<span style="font-size: 20px; font-weight: bold">Контракт</span>
			<vs-dropdown class="float-right ml-3" vs-custom-content vs-trigger-click>
				<b-button variant="outline-dark">
					<i class="fa fa-th"/>
				</b-button>
				<vs-dropdown-menu class="columns-dropdown">
					<vs-drop-down-item v-for="(ind, i) in fields" :key="i">
						<b-checkbox v-model="fixed[`${ind.key}`]">{{ind.label}}</b-checkbox>
					</vs-drop-down-item>
				</vs-dropdown-menu>
			</vs-dropdown>
			<b-input-group class="float-right shadow" style="width: 250px">
				<template #prepend>
					<b-button disabled class="fa fa-search"/>
				</template>
				<b-form-input v-model="payload.value" placeholder="Поиск"/>
				<template #append>
					<b-button @click="createForm" variant="outline-primary" class="fa fa-plus"/>
				</template>
			</b-input-group>
		</template>
		<b-overlay :show="loading" rounded="sm">
			<b-table :items="list" :fields="computedFields" :busy="loading" hover striped bordered show-empty>
				<template slot="empty" slot-scope="scope">
					<h4 class="text-center">{{ $t('empty') }}</h4>
				</template>
				<template slot="id" slot-scope="data">
					{{ paginate(data.index, payload.page, payload.limit) }}
				</template>
				<template slot="actions" slot-scope="data">
					<b-badge v-if="data.item.status==='READY'" @click="viewForm(data.item.id)" pill variant="dark" class="cursor-pointer p-1"><span style="font-size: 14px" class="fa fa-eye"/></b-badge>
					<b-badge v-if="data.item.status==='READY'" @click="viewHistoryDoc(data.item.id, data.item)" variant="info" class="cursor-pointer ml-2 p-1"><span style="font-size: 14px" class="fa fa-history"/></b-badge>
					<b-badge v-if="data.item.status==='READY'" @click="addForm(data.item.id)" variant="primary" class="cursor-pointer ml-2 p-1"><span style="font-size: 14px" class="fa fa-plus"/></b-badge>
					<b-badge v-if="data.item.status==='READY'&&$can('contract', 'finish')" @click="addPaymentForm(data.item.id)" variant="success" class="cursor-pointer ml-2 p-1"><span style="font-size: 14px" class="fa fa-money"/></b-badge>
					<b-badge v-if="data.item.status==='SUSPENDED'" @click="editForm(data.item.id)" variant="primary" class="cursor-pointer p-1"><span style="font-size: 14px" class="fa fa-edit"/></b-badge>
					<b-badge v-if="data.item.status==='SUSPENDED'" @click="deleteForm(data.item.id)" variant="danger" class="cursor-pointer ml-2 p-1"><span style="font-size: 14px" class="fa fa-trash"/></b-badge>
				</template>
			</b-table>
			<nav class="text-center mt-3">
				<b-pagination-new background :total="total" layout="prev, pager, next" :page-size="payload.limit" :current-page.sync="payload.page"/>
			</nav>
		</b-overlay>

		<!--		Create / Edit		-->
		<b-modal v-model="createOrEditModal" size="xl" :busy="loading" :title="create&&add ? `Создать ${!oldForm ? '' : ` - Допсоглашение контракта ${oldForm.contractNumber} / ${oldForm.contractDate}`}` : `Редактировать ${!oldForm ? '' : ` - Допсоглашение контракта ${oldForm.contractNumber} / ${oldForm.contractDate}`}`" hide-footer no-close-on-backdrop>
			<b-overlay :show="loading" rounded="sm">
				<steps :active="active" finish-status="success" simple>
					<step title="Информация"/>
					<step :title="form.contractType&&form.contractType=='2'?`Товары и Платежи`:`Платежи`"/>
					<step title="Форма"/>
				</steps>
				<!--			Step - Информация			-->
				<div v-if="active===0">
					<b-row class="mt-3">
						<b-col>
							<b-input-group>
								<template #prepend>
									<b-button disabled style="width: 150px">Номер контракта<span class="text-danger">*</span></b-button>
								</template>
								<b-form-input v-model="form.contractNumber"/>
							</b-input-group>
						</b-col>
						<b-col>
							<b-input-group>
								<template #prepend>
									<b-button disabled style="width: 150px">{{$t('promo-to-product.regDate')}}<span class="text-danger">*</span></b-button>
								</template>
								<date-picker v-model="form.contractDate" lang="ru" format="DD-MM-YYYY" value-type="format" style="margin-left: -16px"/>
							</b-input-group>
						</b-col>
						<b-col>
							<b-input-group>
								<template #prepend>
									<b-button disabled style="width: 150px">Форма контракта <span class="text-danger">*</span></b-button>
								</template>
								<b-form-select v-model="form.contractType" name="contractType" @change="selectType">
									<option v-for="(selectOption, indexOpt) in contractTypes" :key="`contractType-${indexOpt}`" :value="selectOption.value">{{ selectOption.name }}</option>
									<template slot="first">
										<option :value="null">
											-- Форма контракта --
										</option>
									</template>
								</b-form-select>
							</b-input-group>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col>
							<b-input-group>
								<template #prepend>
									<b-button disabled style="width: 150px">Тип контракта <span class="text-danger">*</span></b-button>
								</template>
								<b-form-select v-model="form.typeId" name="type" :disabled="!oldForm?false:true">
									<option v-for="(selectOption, indexOpt) in types" :key="`type-${indexOpt}`" :value="selectOption.id">{{ selectOption.name }}</option>
									<template slot="first">
										<option :value="null">
											-- Тип контракта --
										</option>
									</template>
								</b-form-select>
							</b-input-group>
						</b-col>
						<b-col>
							<b-input-group>
								<template #prepend>
									<b-button disabled style="width: 150px">Тип контрагента <span class="text-danger">*</span></b-button>
								</template>
								<b-form-select v-model="form.stageId" name="stage" :disabled="!oldForm?false:true">
									<option v-for="(selectOption, indexOpt) in stages" :key="`stage-${indexOpt}`" :value="selectOption.id">{{ selectOption.name }}</option>
									<template slot="first">
										<option :value="null">
											-- Тип контрагента --
										</option>
									</template>
								</b-form-select>
							</b-input-group>
						</b-col>
						<b-col>
							<b-input-group>
								<template #prepend>
									<b-button disabled style="width: 150px">Контрагент <span class="text-danger">*</span></b-button>
								</template>
								<b-form-select v-model="form.contragentId" name="contragent" :disabled="!oldForm?false:true">
									<option v-for="(selectOption, indexOpt) in contragents" :key="`contragent-${indexOpt}`" :value="selectOption.id">{{ selectOption.fullName }}</option>
									<template slot="first">
										<option :value="null">
											-- Контрагент --
										</option>
									</template>
								</b-form-select>
							</b-input-group>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col>
							<b-input-group>
								<template #prepend>
									<b-button disabled style="width: 150px">Ответственный <span class="text-danger">*</span></b-button>
								</template>
								<b-form-select v-model="form.employeeId" name="employee">
									<option v-for="(selectOption, indexOpt) in employees" :key="`employee-${indexOpt}`" :value="selectOption.id">{{ selectOption.firstName }} {{ selectOption.lastName }} {{ selectOption.middleName }}</option>
									<template slot="first">
										<option :value="null">
											-- Ответственный --
										</option>
									</template>
								</b-form-select>
							</b-input-group>
						</b-col>
						<b-col>
							<b-input-group>
								<template #prepend>
									<b-button disabled style="width: 150px">Тип валюты <span class="text-danger">*</span></b-button>
								</template>
								<b-form-select v-model="form.currencyId" name="currency" :disabled="!oldForm?false:true">
									<option v-for="(selectOption, indexOpt) in currencys" :key="`currency-${indexOpt}`" :value="selectOption.id">{{ selectOption.name }}</option>
									<template slot="first">
										<option :value="null">
											-- Тип валюты --
										</option>
									</template>
								</b-form-select>
							</b-input-group>
						</b-col>
						<b-col>
							<b-input-group>
								<template #prepend>
									<b-button disabled style="width: 150px">Срок окончания <span class="text-danger">*</span></b-button>
								</template>
								<date-picker v-model="form.endDate" lang="ru" format="DD-MM-YYYY" value-type="format" style="margin-left: -16px"/>
							</b-input-group>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col v-if="form.contractType&&form.contractType=='1'" cols="4">
							<b-input-group>
								<template #prepend>
									<b-button disabled style="width: 150px">Сумма <span class="text-danger">*</span><span v-if="oldForm&&oldForm.amountPriceUzs&&oldForm.amountPriceUzs!==''" class="ml-1"> {{ oldForm.amountPriceUzs }} + </span></b-button>
								</template>
								<template #append>
									<b-button disabled>{{ currencyName }}</b-button>
								</template>
								<b-form-input v-model="form.amountPriceUzs" @input="changePrice" type="number"/>
							</b-input-group>
						</b-col>
						<b-col cols="4">
							<b-form-textarea v-model="form.reason" rows="2" placeholder="Примечание"/>
						</b-col>
						<b-col cols="4" v-for="(file, index) in files" :key="`file-${index}`">
							<upload v-if="!file" :action="`${publicPath}/contract-management/upload-file/${form.id}`" :on-success="fileSuccess" :before-upload="beforeFileUpload" :on-error="fileError" class="avatar-uploader" :show-file-list="false">
								<i class="el-icon-plus avatar-uploader-icon"/>
							</upload>
							<div v-else>
								<b-card style="min-height: 70px; position: relative">
									<b-row>
										<b-col cols="2">
											<img v-if="file.contentType==='.xls'||file.contentType==='.xlsx'" src="../../assets/file-img/excel.png" style="width: 60px; height: 60px">
											<img v-if="file.contentType==='.doc'||file.contentType==='.docx'" src="../../assets/file-img/word.png" style="width: 60px; height: 60px">
											<img v-if="file.contentType==='.pdf'" src="../../assets/file-img/pdf.png" style="width: 60px; height: 60px">
										</b-col>
										<b-col>
											<p class="ml-2">{{ file.fileName }}</p>
										</b-col>
									</b-row>
									<b-badge v-if="file.contractId==form.id" @click="deleteFile(file, index)" variant="danger" style="position: absolute; right: -10px; top: -10px; font-size: 18px; cursor: pointer"><i class="fa fa-close"/></b-badge>
									<a :href="`${mediaPath}/${file.url}`" download class="badge badge-primary" style="position: absolute; right: -10px; bottom: -10px; font-size: 18px; cursor: pointer"><i class="fa fa-download"/></a>
								</b-card>
							</div>
						</b-col>
					</b-row>
				</div>
				<!--			Step - Товары и Платежи			-->
				<div v-if="active===1">
					<div v-if="form.contractType&&form.contractType=='2'" class="text-center mt-1 mb-1"><b>Товары контракта</b></div>
					<b-row v-if="form.contractType&&form.contractType=='2'" class="mt-3">
						<b-col>
							<multiselect v-model="item" :options="items" :searchable="true" :show-labels="false" :close-on-select="true" label="name" track-by="id" @search-change="getItems($event)" :placeholder="$t('incomes.create.product')">
								<template slot="singleLabel" slot-scope="props">
									<span>
										<b>{{props.option.barcode }}</b> / {{ props.option.name }}
									</span>
								</template>
								<template slot="option" slot-scope="option">
									<span>
										<b>{{option.option.barcode }}</b> / {{ option.option.name }}
									</span>
								</template>
							</multiselect>
						</b-col>
<!--						<b-col class="d-flex justify-content-end" style="align-self: center;">-->
<!--							<b-form-file v-model="form.excelFile" :browse-text="$t('excel-export.view-excel')" :placeholder="$t('excel-export.select-file')" drop-placeholder="Перетащите файл сюда ..." size="sm" name="file" style="width: 68%; margin-right: 10px" v-validate="{required:true}" :state="fileSelected" accept=".xls, .xlsx">-->
<!--								<template slot="file-name" slot-scope="{ names }">-->
<!--									<b-badge variant="dark">{{ names[0] }}</b-badge>-->
<!--									<b-badge v-if="names.length > 1" variant="dark" class="ml-1">+ {{ names.length - 1 }} More files</b-badge>-->
<!--								</template>-->
<!--							</b-form-file>-->
<!--							<a style="font-size: 16px;" :href="`${publicPath}excel/Приходные товары.xlsx`" disabled download>{{ $t('excel.title') }}</a>-->
<!--							<b-button @click="uploadFileToServer" class="pull-right" variant="primary">-->
<!--								{{ $t('excel-export.download-file') }}-->
<!--							</b-button>-->
<!--						</b-col>-->
					</b-row>
					<b-row v-if="form.contractType&&form.contractType=='2'&&item" class="mt-3">
						<b-col>
							<b-input-group>
								<template #prepend>
									<b-button disabled style="width: 140px">Входящая цена</b-button>
								</template>
								<b-form-input v-model="item.incomingPriceUzs" type="number" @keyup.enter="addItem"/>
								<template #append>
									<b-button disabled style="width: 60px">EUR</b-button>
								</template>
							</b-input-group>
						</b-col>
						<b-col>
							<b-input-group>
								<template #prepend>
									<b-button disabled style="width: 140px">Количество</b-button>
								</template>
								<b-form-input v-model="item.count" type="number" @keyup.enter="addItem"/>
								<template #append>
									<b-button disabled style="width: 60px">{{ item.unitName }}</b-button>
								</template>
							</b-input-group>
						</b-col>
						<b-col cols="2">
							<b-button @click="addItem" variant="outline-primary">Добавить</b-button>
						</b-col>
					</b-row>
					<b-row v-if="form.contractType&&form.contractType=='2'&&oldForm&&oldForm.contractItems" class="mt-3">
						<b-col>
							<b-table :items="oldForm.contractItems" :fields="itemFields" hover striped bordered show-empty ref="itemTable">
								<template slot="empty" slot-scope="scope">
									<h4 class="text-center">{{ $t('empty') }}</h4>
								</template>
								<template slot="id" slot-scope="data">
									{{ data.index+1 }}
								</template>
								<template slot="multiBarcode" slot-scope="data">
									<div v-for="b in data.item.multiBarcodes">{{ b.barcode }}</div>
								</template>
								<template slot="incomingPriceUzs" slot-scope="data">
									{{ data.item.incomingPriceUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}
								</template>
								<template slot="amount" slot-scope="data">
									{{ (data.item.count*data.item.incomingPriceUzs) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}
								</template>
							</b-table>
						</b-col>
					</b-row>
					<b-row v-if="form.contractType&&form.contractType=='2'" class="mt-3">
						<b-col>
							<b-table :items="form.contractItems" :fields="itemFields" hover striped bordered show-empty ref="itemTable">
								<template slot="empty" slot-scope="scope">
									<h4 class="text-center">{{ $t('empty') }}</h4>
								</template>
								<template slot="id" slot-scope="data">
									{{ data.index+1 }}
								</template>
								<template slot="multiBarcode" slot-scope="data">
									<div v-for="b in data.item.multiBarcodes">{{ b.barcode }}</div>
								</template>
								<template slot="incomingPriceUzs" slot-scope="data">
									{{ data.item.incomingPriceUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}
								</template>
								<template slot="amount" slot-scope="data">
									{{ (data.item.count*data.item.incomingPriceUzs) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}
								</template>
								<template slot="action" slot-scope="data">
									<b-badge @click="deleteItem(data.index)" variant="danger" class="cursor-pointer"><span style="font-size: 12px" class="fa fa-trash"/></b-badge>
								</template>
							</b-table>
						</b-col>
					</b-row>
					<b-row v-if="form.contractType&&form.contractType=='2'">
						<b-col/>
						<b-col cols="4">
							<b-input-group>
								<template #prepend>
									<b-button disabled>Сумма <span class="text-danger">*</span><span v-if="oldForm&&oldForm.amountPriceUzs&&oldForm.amountPriceUzs!==''" class="ml-1"> {{ oldForm.amountPriceUzs }} + </span></b-button>
								</template>
								<template #append>
									<b-button disabled>{{ currencyName }}</b-button>
								</template>
								<b-form-input v-model="form.amountPriceUzs" @input="changePrice" type="number" disabled/>
							</b-input-group>
						</b-col>
					</b-row>
					<hr v-if="form.contractType&&form.contractType=='2'">
					<div class="text-center mt-1 mb-1"><b>Платежи контракта</b></div>
					<h4 class="text-center mt-2"><b>Сумма : </b> <span>{{ form.amountPriceUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</span> <b>{{ currencyName }}</b></h4>
					<div v-for="(pay, index) in form.payments" :key="`pay-${index}`">
						<b-row class="mt-3">
							<b-col>
								<b-input-group>
									<template #prepend>
										<b-button disabled style="width: 50px">%</b-button>
									</template>
									<b-form-input v-model="pay.percentage" @input="setPrice($event, pay, index)" type="number"/>
								</b-input-group>
							</b-col>
							<b-col>
								<b-input-group>
									<template #prepend>
										<b-button disabled style="width: 50px">{{ currencyName }}</b-button>
									</template>
									<b-form-input v-model="pay.price" @input="setPercentage($event, pay, index)" type="number"/>
								</b-input-group>
							</b-col>
							<b-col cols="4">
								<b-input-group>
									<template #prepend>
										<b-button disabled style="width: 150px">Срок окончания <span class="text-danger">*</span></b-button>
									</template>
									<date-picker v-model="pay.date" @change="changeDate($event, index)" lang="ru" format="DD-MM-YYYY" value-type="format" style="margin-left: -16px"/>
								</b-input-group>
							</b-col>
							<b-col cols="2">
								<div class="text-center">
									<b-button @click="addPayment" class="fa fa-plus mr-2" variant="success"/>
									<b-button v-if="form.payments.length!==1" @click="deletePayment(index)" class="fa fa-close" variant="danger"/>
								</div>
							</b-col>
						</b-row>
						<hr v-if="index!==form.payments.length-1">
					</div>
				</div>
				<!--			Step - Форма			-->
				<div v-if="active===2">
					<div style="border: 1px solid black; padding: 5px">
						<h5 class="text-center mt-2 mb-3"><b>Договор</b></h5>
						<b-row>
							<b-col cols="4">
								<b>Номер документа: </b> <span> {{ form.regNumber }}</span>
								<br>
								<b>Номер контракта: </b> <span> {{ form.contractNumber }}</span>
								<br>
								<b>{{$t('promo-to-product.regDate')}}: </b> <span> {{ form.contractDate }}</span>
								<br>
								<b>Форма контракта: </b> <span> {{ contractTypeName(form.contractType) }}</span>
							</b-col>
							<b-col cols="4">
								<b>Тип контракта: </b> <span> {{ typeName(form.typeId) }}</span>
								<br>
								<b>Тип контрагента: </b> <span> {{ stageName(form.stageId) }}</span>
								<br>
								<b>Контрагент: </b> <span> {{ contragentName(form.contragentId) }}</span>
							</b-col>
							<b-col cols="4">
								<b>Ответственный: </b> <span> {{ employeeName(form.employeeId) }}</span>
								<br>
								<b>Срок окончания: </b> <span> {{ form.endDate }}</span>
								<br>
								<b>Примечание: </b> <p> {{ form.reason }}</p>
							</b-col>
						</b-row>
						<b-row class="mt-3" v-if="form.contractItems&&form.contractItems.length>0">
							<b-col>
								<div class="text-center mb-2"><b>Товары контракта</b></div>
								<b-table :items="form.contractItems" :fields="itemFields" hover striped bordered show-empty ref="itemTable">
									<template slot="empty" slot-scope="scope">
										<h4 class="text-center">{{ $t('empty') }}</h4>
									</template>
									<template slot="id" slot-scope="data">
										{{ data.index+1 }}
									</template>
									<template slot="multiBarcode" slot-scope="data">
										<div v-for="b in data.item.multiBarcodes">{{ b.barcode }}</div>
									</template>
									<template slot="incomingPriceUzs" slot-scope="data">
										{{ data.item.incomingPriceUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}
									</template>
									<template slot="amount" slot-scope="data">
										{{ (data.item.count*data.item.incomingPriceUzs) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="mt-3">
							<b-col>
								<div class="text-center mb-2"><b>Платежи контракта</b></div>
								<table class="table table-hover table-striped table-bordered">
									<thead>
										<tr>
											<th class="text-center">№</th>
											<th class="text-center" style="width: 30%">%</th>
											<th class="text-center" style="width: 30%">{{ currencyName }}</th>
											<th class="text-center" style="width: 30%">Срок окончания</th>
											<th class="text-center" style="width: 10%">Статус платежа</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(pay, index) in form.payments" :key="`pay-view-${index}`">
											<td class="text-center">{{ index+1 }}</td>
											<td class="text-center">{{ pay.percentage }}</td>
											<td class="text-center">{{ pay.price | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</td>
											<td class="text-center">{{ pay.date }}</td>
											<td class="text-center"><i v-if="!pay.isPaid" style="font-size: 16px" class="fa fa-window-close text-danger"/><i v-else style="font-size: 16px" class="fa fa-check-square text-success"/></td>
										</tr>
										<tr>
											<td colspan="2" class="text-center"><b>Общая сумма</b></td>
											<td class="text-center">{{ form.amountPriceUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</td>
											<td/>
											<td/>
										</tr>
									</tbody>
								</table>
							</b-col>
						</b-row>
						<b-row class="mt-3">
							<b-col cols="4" v-for="(file, index) in files" :key="`file-view-${index}`" v-if="file">
								<b-card style="min-height: 70px; position: relative">
									<b-row>
										<b-col cols="2">
											<img v-if="file.contentType==='.xls'||file.contentType==='.xlsx'" src="../../assets/file-img/excel.png" style="width: 60px; height: 60px">
											<img v-if="file.contentType==='.doc'||file.contentType==='.docx'" src="../../assets/file-img/word.png" style="width: 60px; height: 60px">
											<img v-if="file.contentType==='.pdf'" src="../../assets/file-img/pdf.png" style="width: 60px; height: 60px">
										</b-col>
										<b-col>
											<p class="ml-2">{{ file.fileName }}</p>
										</b-col>
									</b-row>
									<a :href="`${mediaPath}/${file.url}`" download class="badge badge-primary" style="position: absolute; right: -10px; bottom: -10px; font-size: 18px; cursor: pointer"><i class="fa fa-download"/></a>
								</b-card>
							</b-col>
						</b-row>
					</div>
				</div>
				<hr>
				<b-row>
					<b-col align="left">
						<b-button v-if="active>0" @click="change(false)" variant="primary">Назад</b-button>
						<b-button v-else variant="outline-danger" @click="createOrEditModal=false">{{ $t('cancel') }}</b-button>
					</b-col>
					<b-col align="right">
						<span v-if="active<2">
							<b-button variant="warning" @click="save('SUSPENDED')" class="mr-2">{{ $t('save') }}</b-button>
							<b-button @click="change(true)" variant="primary">Далее</b-button>
						</span>
						<span v-else>
							<b-button variant="warning" @click="save('SUSPENDED')" class="mr-2">{{ $t('save') }}</b-button>
							<b-button v-if="$can('contract', 'finish')" variant="success" @click="save('READY')">{{ $t('save-finish') }}</b-button>
						</span>
					</b-col>
				</b-row>
			</b-overlay>
		</b-modal>

		<!--		Payment		-->
		<b-modal v-model="paymentModal" size="xl" :busy="loading" :title="'Платежи контракта - ' + !oldForm ? '' : `${oldForm.contractNumber} / ${oldForm.contractDate}`" hide-footer no-close-on-backdrop>
			<b-overlay :show="loading" rounded="sm">
				<div v-if="!oldForm"></div>
				<div v-else>
					<h5 class="text-center mt-2 mb-3"><b>Договор</b></h5>
					<b-row>
						<b-col cols="4">
							<b>Номер контракта: </b> <span> {{ oldForm.contractNumber }}</span>
							<br>
							<b>{{$t('promo-to-product.regDate')}}: </b> <span> {{ oldForm.contractDate }}</span>
							<br>
							<b>Форма контракта: </b> <span> {{ contractTypeName(oldForm.contractType) }}</span>
						</b-col>
						<b-col cols="4">
							<b>Тип контракта: </b> <span> {{ typeName(oldForm.typeId) }}</span>
							<br>
							<b>Тип контрагента: </b> <span> {{ stageName(oldForm.stageId) }}</span>
							<br>
							<b>Контрагент: </b> <span> {{ contragentName(oldForm.contragentId) }}</span>
						</b-col>
						<b-col cols="4">
							<b>Ответственный: </b> <span> {{ employeeName(oldForm.employeeId) }}</span>
							<br>
							<b>Срок окончания: </b> <span> {{ oldForm.endDate }}</span>
							<br>
							<b>Примечание: </b> <p> {{ oldForm.reason }}</p>
						</b-col>
					</b-row>
					<b-row class="mt-3" v-if="oldForm.contractItems&&oldForm.contractItems.length>0">
						<b-col>
							<b-table :items="oldForm.contractItems" :fields="itemFields" hover striped bordered show-empty ref="itemTable">
								<template slot="empty" slot-scope="scope">
									<h4 class="text-center">{{ $t('empty') }}</h4>
								</template>
								<template slot="id" slot-scope="data">
									{{ data.index+1 }}
								</template>
								<template slot="multiBarcode" slot-scope="data">
									<div v-for="b in data.item.multiBarcodes">{{ b.barcode }}</div>
								</template>
								<template slot="incomingPriceUzs" slot-scope="data">
									{{ data.item.incomingPriceUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}
								</template>
								<template slot="amount" slot-scope="data">
									{{ (data.item.count*data.item.incomingPriceUzs) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}
								</template>
							</b-table>
						</b-col>
					</b-row>
					<b-row class="mt-3" v-for="(oldContract, indexOld) in oldForm.oldPayments" :key="`old-contract-${indexOld}`">
						<b-col>
							<table class="table table-hover table-striped table-bordered">
								<thead>
								<tr>
									<td colspan="5" class="text-center">
										<b>Номер контракта: </b> <span>{{ oldContract.contractNumber }}</span> <b> / </b>
										<b>{{$t('promo-to-product.regDate')}}: </b> <span>{{ oldContract.contractDate }}</span> <b> / </b>
										<b>Срок окончания: </b> <span>{{ oldContract.endDate }}</span>
									</td>
								</tr>
								<tr>
									<th class="text-center">№</th>
									<th class="text-center" style="width: 30%">%</th>
									<th class="text-center" style="width: 30%">{{ currencyName }}</th>
									<th class="text-center" style="width: 30%">Срок окончания</th>
									<th class="text-center" style="width: 10%">Статус платежа</th>
								</tr>
								</thead>
								<tbody>
								<tr v-for="(pay, index) in oldContract.payments" :key="`pay-view-old-${index}`">
									<td class="text-center">{{ index+1 }}</td>
									<td class="text-center">{{ pay.percentage }}</td>
									<td class="text-center">{{ pay.price | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</td>
									<td class="text-center">{{ pay.date }}</td>
									<td class="text-center"><i v-if="!pay.isPaid" style="font-size: 16px" class="fa fa-window-close text-danger"/><i v-else style="font-size: 16px" class="fa fa-check-square text-success"/></td>
								</tr>
								<tr>
									<td colspan="2" class="text-center"><b>Общая сумма</b></td>
									<td class="text-center">{{ oldContract.amountPriceUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</td>
									<td/>
									<td/>
								</tr>
								</tbody>
							</table>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col>
							<table class="table table-hover table-striped table-bordered">
								<thead>
								<tr>
									<th class="text-center">№</th>
									<th class="text-center" style="width: 30%">%</th>
									<th class="text-center" style="width: 30%">{{ currencyName }}</th>
									<th class="text-center" style="width: 30%">Срок окончания</th>
									<th class="text-center" style="width: 10%">Статус платежа</th>
								</tr>
								</thead>
								<tbody>
								<tr v-for="(pay, index) in oldForm.payments" :key="`pay-view-${index}`">
									<td class="text-center">{{ index+1 }}</td>
									<td class="text-center">{{ pay.percentage }}</td>
									<td class="text-center">{{ pay.price | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</td>
									<td class="text-center">{{ pay.date }}</td>
									<td class="text-center"><i v-if="!pay.isPaid" style="font-size: 16px" class="fa fa-window-close text-danger"/><i v-else style="font-size: 16px" class="fa fa-check-square text-success"/></td>
								</tr>
								<tr>
									<td colspan="2" class="text-center"><b>Общая сумма</b></td>
									<td class="text-center">{{ oldForm.amountPriceUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</td>
									<td/>
									<td/>
								</tr>
								</tbody>
							</table>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col cols="4" v-for="(file, index) in files" :key="`file-view-${index}`" v-if="file">
							<b-card style="min-height: 70px; position: relative">
								<b-row>
									<b-col cols="2">
										<img v-if="file.contentType==='.xls'||file.contentType==='.xlsx'" src="../../assets/file-img/excel.png" style="width: 60px; height: 60px">
										<img v-if="file.contentType==='.doc'||file.contentType==='.docx'" src="../../assets/file-img/word.png" style="width: 60px; height: 60px">
										<img v-if="file.contentType==='.pdf'" src="../../assets/file-img/pdf.png" style="width: 60px; height: 60px">
									</b-col>
									<b-col>
										<p class="ml-2">{{ file.fileName }}</p>
									</b-col>
								</b-row>
								<a :href="`${mediaPath}/${file.url}`" download class="badge badge-primary" style="position: absolute; right: -10px; bottom: -10px; font-size: 18px; cursor: pointer"><i class="fa fa-download"/></a>
							</b-card>
						</b-col>
					</b-row>
				</div>
				<hr>
				<div v-if="!oldForm"/>
				<b-row v-else class="mt-3">
					<b-col>
						<b-input-group>
							<template #prepend>
								<b-button disabled>Платежи</b-button>
							</template>
							<b-form-select v-model="payment.id" name="payment">
								<option v-for="(selectOption, indexOpt) in allPayments" :key="`payment-${indexOpt}`" :value="selectOption.id" :disabled="selectOption.isPaid">{{ selectOption.percentage }} % / {{ selectOption.price }} {{ currencyName }} / {{ selectOption.date }}</option>
								<template slot="first">
									<option :value="null">
										-- Платежи --
									</option>
								</template>
							</b-form-select>
						</b-input-group>
					</b-col>
					<b-col cols="4">
						<b-input-group>
							<template #prepend>
								<b-button disabled style="width: 150px">{{$t('promo-to-product.regDate')}}</b-button>
							</template>
							<date-picker v-model="payment.payDate" lang="ru" format="DD-MM-YYYY" value-type="format" style="margin-left: -16px"/>
						</b-input-group>
					</b-col>
					<b-col cols="4">
						<b-input-group>
							<template #prepend>
								<b-button disabled>Коммент</b-button>
							</template>
							<b-form-input v-model="payment.reason" type="text"/>
						</b-input-group>
					</b-col>
				</b-row>
				<hr>
				<b-row>
					<b-col align="left">
						<b-button variant="outline-danger" @click="paymentModal=false; oldForm=null; payment={}">{{ $t('cancel') }}</b-button>
					</b-col>
					<b-col align="right">
						<b-button variant="success" @click="savePayment">{{ $t('save') }}</b-button>
					</b-col>
				</b-row>
			</b-overlay>
		</b-modal>

		<!--		History		-->
		<b-modal v-model="historyModal" size="xl" :busy="loading" :title="`История контракта - ${form.regNumber} / ${form.contractNumber}`" hide-footer no-close-on-backdrop>
			<div v-for="(contract, index) in form.parents" :key="`contracts-${index}`">
				<div>
					<h4 class="text-center mt-2 mb-3"><b v-if="index===0">1. Договор</b><b v-else>{{ index+1 }}. Допсоглашение контракта - {{ form.parents[index-1].regNumber }} / {{ form.parents[index-1].contractNumber }}</b></h4>
					<b-row>
						<b-col cols="4">
							<b>Номер документа: </b> <span> {{ contract.regNumber }}</span>
							<br>
							<b>Номер контракта: </b> <span> {{ contract.contractNumber }}</span>
							<br>
							<b>{{$t('promo-to-product.regDate')}}: </b> <span> {{ contract.contractDate }}</span>
							<br>
							<b>Форма контракта: </b> <span> {{ contractTypeName(contract.contractType) }}</span>
						</b-col>
						<b-col cols="4">
							<b>Тип контракта: </b> <span> {{ contract.typeName }}</span>
							<br>
							<b>Тип контрагента: </b> <span> {{ contract.stageName }}</span>
							<br>
							<b>Контрагент: </b> <span> {{ contract.contragentName }}</span>
						</b-col>
						<b-col cols="4">
							<b>Ответственный: </b> <span> {{ contract.employeeName }}</span>
							<br>
							<b>Срок окончания: </b> <span> {{ contract.endDate }}</span>
							<br>
							<b>Примечание: </b> <span> {{ contract.reason }}</span>
						</b-col>
					</b-row>
				</div>
				<div class="text-center mt-1 mb-1"><b>Приходы контракта</b></div>
				<b-table class="generalTableClass mt-2 poin" id="incomeTable" :items="contract.incomeDocs?contract.incomeDocs:[]" :fields="income" hover striped bordered show-empty>
					<!-- EMPTY SLOT FOR TABLE -->
					<template slot="empty" slot-scope="scope">
						<h4>{{ $t('empty') }}</h4>
					</template>
					<!-- EMPTY SLOT FOR TABLE -->
					<template slot="id" slot-scope="data">
						<strong>{{ data.index+1 }}</strong>
					</template>
					<template slot="allItemAmount" slot-scope="data">
						<span>{{ data.item.allItemAmount | currency({symbol: currencyName, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</span>
					</template>
					<template slot="actions" slot-scope="data">
						<div class="text-dark">
							<b-link :to="`/warehouse-management/income-view/view/${data.item.id}`" target="_blank">
								<i class="fa fa-eye" style="font-size: 18px"/>
							</b-link>
						</div>
					</template>
				</b-table>
				<div class="text-center mt-1 mb-1"><b>Платежи контракта</b></div>
				<b-row class="mt-3">
					<b-col>
						<table class="table table-hover table-striped table-bordered">
							<thead>
							<tr>
								<th class="text-center">№</th>
								<th class="text-center" style="width: 30%">%</th>
								<th class="text-center" style="width: 30%">{{ currencyName }}</th>
								<th class="text-center" style="width: 30%">Срок окончания</th>
								<th class="text-center" style="width: 10%">Статус платежа</th>
							</tr>
							</thead>
							<tbody>
							<tr v-for="(pay, index) in contract.payments" :key="`pay-view-${index}`">
								<td class="text-center">{{ index+1 }}</td>
								<td class="text-center">{{ pay.percentage }}</td>
								<td class="text-center">{{ pay.price | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</td>
								<td class="text-center">{{ pay.date }}</td>
								<td class="text-center"><i v-if="!pay.isPaid" style="font-size: 16px" class="fa fa-window-close text-danger"/><i v-else style="font-size: 16px" class="fa fa-check-square text-success"/></td>
							</tr>
							<tr>
								<td colspan="2" class="text-center"><b>Общая сумма</b></td>
								<td class="text-center">{{ contract.amountPriceUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</td>
								<td/>
								<td/>
							</tr>
							</tbody>
						</table>
					</b-col>
				</b-row>
				<hr>
			</div>
			<div>
				<div>
					<h4 class="text-center mt-2 mb-3"><b v-if="form.parents&&form.parents.length>0">{{ form.parents.length+1 }}. Допсоглашение контракта - {{ form.parents[form.parents.length-1].regNumber }} / {{ form.parents[form.parents.length-1].contractNumber }}</b><b v-else>1. Договор</b></h4>
					<b-row>
						<b-col cols="4">
							<b>Номер документа: </b> <span> {{ form.regNumber }}</span>
							<br>
							<b>Номер контракта: </b> <span> {{ form.contractNumber }}</span>
							<br>
							<b>{{$t('promo-to-product.regDate')}}: </b> <span> {{ form.contractDate }}</span>
							<br>
							<b>Форма контракта: </b> <span> {{ contractTypeName(form.contractType) }}</span>
						</b-col>
						<b-col cols="4">
							<b>Тип контракта: </b> <span> {{ form.typeName }}</span>
							<br>
							<b>Тип контрагента: </b> <span> {{ form.stageName }}</span>
							<br>
							<b>Контрагент: </b> <span> {{ form.contragentName }}</span>
						</b-col>
						<b-col cols="4">
							<b>Ответственный: </b> <span> {{ form.employeeName }}</span>
							<br>
							<b>Срок окончания: </b> <span> {{ form.endDate }}</span>
							<br>
							<b>Примечание: </b> <span> {{ form.reason }}</span>
						</b-col>
					</b-row>
				</div>
				<div class="text-center mt-1 mb-1"><b>Приходы контракта</b></div>
				<b-table class="generalTableClass mt-2 poin" id="incomeTable" :items="form.incomeDocs" :fields="income" hover striped bordered show-empty>
					<!-- EMPTY SLOT FOR TABLE -->
					<template slot="empty" slot-scope="scope">
						<h4>{{ $t('empty') }}</h4>
					</template>
					<!-- EMPTY SLOT FOR TABLE -->
					<template slot="id" slot-scope="data">
						<strong>{{ data.index+1 }}</strong>
					</template>
					<template slot="allItemAmount" slot-scope="data">
						<span>{{ data.item.allItemAmount | currency({symbol: currencyName, fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</span>
					</template>
					<template slot="actions" slot-scope="data">
						<div class="text-dark">
							<b-link :to="`/warehouse-management/income-view/view/${data.item.id}`" target="_blank">
								<i class="fa fa-eye" style="font-size: 18px"/>
							</b-link>
						</div>
					</template>
				</b-table>
				<div class="text-center mt-1 mb-1"><b>Платежи контракта</b></div>
				<b-row class="mt-3">
					<b-col>
						<table class="table table-hover table-striped table-bordered">
							<thead>
							<tr>
								<th class="text-center">№</th>
								<th class="text-center" style="width: 30%">%</th>
								<th class="text-center" style="width: 30%">{{ currencyName }}</th>
								<th class="text-center" style="width: 30%">Срок окончания</th>
								<th class="text-center" style="width: 10%">Статус платежа</th>
							</tr>
							</thead>
							<tbody>
							<tr v-for="(pay, index) in form.payments" :key="`pay-view-${index}`">
								<td class="text-center">{{ index+1 }}</td>
								<td class="text-center">{{ pay.percentage }}</td>
								<td class="text-center">{{ pay.price | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</td>
								<td class="text-center">{{ pay.date }}</td>
								<td class="text-center"><i v-if="!pay.isPaid" style="font-size: 16px" class="fa fa-window-close text-danger"/><i v-else style="font-size: 16px" class="fa fa-check-square text-success"/></td>
							</tr>
							<tr>
								<td colspan="2" class="text-center"><b>Общая сумма</b></td>
								<td class="text-center">{{ form.amountPriceUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</td>
								<td/>
								<td/>
							</tr>
							</tbody>
						</table>
					</b-col>
				</b-row>
			</div>
		</b-modal>
	</b-card>
</template>

<script>
import {BOverlay} from 'bootstrapVue2';
import {Steps, Step, Upload} from "element-ui"
import Multiselect from "vue-multiselect";
import GoodsService from "@/services/goods.service";
import ContractService from "./contract.service";
import { Pagination, Table, TableColumn, Tree } from 'element-ui'
import EmployeeSerive from "../../services/employees.service";
import ContrAgentService from "../../services/contragent.service";
import CurrencyService from "../../services/currency.service";
import {mapActions} from "vuex";

export default {
	name: "doc",
	components: {Steps, Step, Upload, Multiselect, "b-pagination-new":Pagination, "el-table":Table, "el-table-column":TableColumn, "el-tree":Tree, BOverlay},
	data() {
		return {
			imageUrl: '',
			loading: false,
			create: true,
			add: false,
			createOrEditModal: false,
			historyModal: false,
			paymentModal: false,
			payment: {},
			active: 0,
			payload: {
				value: '',
				page: 1,
				limit: 20
			},
			form: {
				contractNumber: '',
				contractDate: '',
				endDate: '',
				amountPriceUzs: '',
				contractType: null,
				typeId: null,
				stageId: null,
				employeeId: null,
				currencyId: null,
				contragentId: null,
				payments: [{}],
				contractItems: []
			},
			oldForm: null,
			files: [null],
			item: null,
			items: [],
			types: [],
			stages: [],
			employees: [],
			contragents: [],
			currencys: [],
			contractTypes: [{name: 'Генеральный', value: 1}, {name: 'Одноразовый', value: 2}],
			list: [],
			total: 0,
			fixed: {
				regNumber: true,
				contractNumber: true,
				contractDate: true,
				endDate: true,
				createdDate: false,
				createdBy: false,
				updateDate: false,
				lastModifiedBy: false,
				typeName: true,
				stageName: true,
				employeeName: true,
				contragentName: true
			},
			fields: [
				{key: 'id', label: '№', class: 'text-center', visible: true},
				{key: 'regNumber', label: 'Номер документа', class: 'text-center', visible: true},
				{key: 'contractNumber', label: 'Номер контракта', class: 'text-center', visible: true},
				{key: 'contractDate', label: this.$t('promo-to-product.regDate'), class: 'text-center', visible: true},
				{key: 'endDate', label: 'Срок окончания' , class: 'text-center', visible: true},
				{key: 'createdDate', label: 'Дата создания' , class: 'text-center', visible: false},
				{key: 'createdBy', label: 'Создатель' , class: 'text-center', visible: false},
				{key: 'updateDate', label: 'Дата обновления' , class: 'text-center', visible: false},
				{key: 'lastModifiedBy', label: 'Обнoвлён' , class: 'text-center', visible: false},
				{key: 'typeName', label: 'Тип контракта', class: 'text-center', visible: true},
				{key: 'stageName', label: 'Тип контрагента', class: 'text-center', visible: true},
				{key: 'employeeName', label: 'Ответственный', class: 'text-center', visible: true},
				{key: 'contragentName', label: 'Контрагент', class: 'text-center', visible: true},
				{key: 'actions', label: this.$t('goods.actions'), class: 'text-center', visible: true}
			],
			itemFields: [
				{key: 'id', label: '№', class: 'text-center'},
				{key: 'barcode', label: this.$t("goods.special-barcode"), class: 'text-center'},
				{key: 'name', label: this.$t("goods.name")},
				{key: 'multiBarcode', label:this.$t("goods.barcode") , class: 'text-center'},
				{key: 'incomingPriceUzs', label: this.$t("incomes.create.price"), class: 'text-center'},
				{key: 'count', label: this.$t("sale.kol-vo"), class: 'text-center'},
				{key: 'amount', label: this.$t("Сумма"), class: 'text-center'},
				{key: 'action', label: this.$t(""), class: 'text-center'}
			],
			income: [
				{key: 'id', label: '№', class: 'text-center'},
				{key: 'regNumber', label: this.$t('incomes.name'), class: 'text-center'},
				{key: 'regDate', label: 'Дата регистрации', class: 'text-center'},
				{key: 'docCreatedBy', label: 'Создатель', class: 'text-center'},
				{key: 'docCreatedDate',	label: 'Дата создания',	class: 'text-center'},
				// {key: 'docLastModifiedBy', label: 'Обнoвлён', class: 'text-center'},
				// {key: 'docChangedDate',	label: 'Дата обновления', class: 'text-center'},
				{key: 'reason',	label: 'Сч/фактура', class: 'text-center'},
				{key: 'numberGTD', label: 'Номер ГТД', class: 'text-center'},
				{key: 'extraCosts', label: 'Доп.расходы', class: 'text-center'},
				{key: 'toDepartmentName', label: this.$t('incomes.department'), class: 'text-center'},
				{key: 'allItemAmount', label: 'Сумма прихода', class: 'text-center'},
				// {key: 'comment', label: this.$t('comment'), class: 'text-center'},
				{key: 'actions', label: this.$t('incomes.actions'), class: 'text-center'}
			]
		}
	},
	computed: {
		publicPath () {
			return process.env.VUE_APP_ROOT_API;
		},
		mediaPath () {
			return process.env.VUE_APP_URL;
		},
		computedFields() {
			let tmp = []
			this.fields.forEach(t => {
				if (t.visible)
					tmp.push(t)
			})
			return tmp
		},
		currencyName() {
			let name= ''
			if (this.form && this.form.currencyId) {
				this.currencys.forEach(c => {
					if (c.id === this.form.currencyId)
						name = c.name
				})
			} else if (this.oldForm && this.oldForm.currencyId) {
				this.currencys.forEach(c => {
					if (c.id === this.oldForm.currencyId)
						name = c.name
				})
			}
			return name;
		},
		verifyForm() {
			if (this.form.contractType&&this.form.contractType=='1')
				return (this.form.contractDate&&this.form.contractDate!=''&&this.form.endDate&&this.form.endDate!=''&&this.form.contractType&&this.form.amountPriceUzs&&this.form.amountPriceUzs!=''&&this.form.typeId&&this.form.stageId&&this.form.employeeId&&this.form.currencyId&&this.form.contragentId)
			else
				return (this.form.contractDate&&this.form.contractDate!=''&&this.form.endDate&&this.form.endDate!=''&&this.form.contractType&&this.form.typeId&&this.form.stageId&&this.form.employeeId&&this.form.currencyId&&this.form.contragentId)
		},
		allPayments() {
			let list = [];
			if (this.oldForm&&this.oldForm.oldPayments&&this.oldForm.oldPayments.length>0) {
				this.oldForm.oldPayments.forEach(tmp => {
					tmp.payments.forEach(p => {
						if (!p.isPaid)
							list.push(p);
					})
				})
			}
			this.oldForm.payments.forEach(f => {
				if (!f.isPaid)
					list.push(f);
			})
			return list;
		}
	},
	watch: {
		'payload.value': {
			handler(p) {
				this.getList();
			}
		},
		'payload.page': {
			handler(p) {
				this.getList();
			}
		},
		'form.contractItems': {
			handler(list) {
				if (this.form.contractType&&this.form.contractType=='2') {
					if (list && list.length > 0) {
						let sum = 0;
						list.forEach(tmp => {
							sum += (tmp.incomingPriceUzs * tmp.count)
						})
						this.form.amountPriceUzs = sum.toFixed(2);
					} else {
						this.form.amountPriceUzs = 0
					}
				}
			}
		}
	},
	methods: {
		...mapActions('contragents', ['getNotificationList']),
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		change(next) {
			if (next) {
				if (this.verifyForm) {
					this.active++
				} else {
					this.$vs.notify({title: 'Заполните все обязательные поля !', color: 'danger', icon: 'close', position: 'top-right'});
				}
			} else {
				this.active--
			}
		},
		changePrice() {
			this.form.payments = [{price: '', percentage: '', date: ''}]
		},
		contractTypeName(id) {
			let name = '';
			this.contractTypes.forEach(t => {if (t.value==id) name = t.name})
			return name;
		},
		typeName(id) {
			let name = '';
			this.types.forEach(t => {if (t.id==id) name = t.name})
			return name;
		},
		stageName(id) {
			let name = '';
			this.stages.forEach(t => {if (t.id==id) name = t.name})
			return name;
		},
		contragentName(id) {
			let name = '';
			this.contragents.forEach(t => {if (t.id==id) name = t.fullName})
			return name;
		},
		employeeName(id) {
			let name = '';
			this.employees.forEach(t => {if (t.id==id) name = `${t.firstName} ${t.lastName} ${t.middleName}`})
			return name;
		},
		async getItems($event) {
			this.loading = true
			 await GoodsService.fetchGoodsWithKeyword($event).then(res =>{
				 this.items = res.data
				 this.loading = false
			 }).catch(e => {
				 this.loading = false
				 this.$vs.notify({
					 title: e.message,
					 color: 'danger',
					 icon: 'close',
					 position: 'top-right'
				 });
			 })
		},
		async getTypes() {
			this.loading = true
			 await ContractService.getContractType('').then(res =>{
				 this.types = res.data
				 this.loading = false
			 }).catch(e => {
				 this.loading = false
				 this.$vs.notify({
					 title: e.message,
					 color: 'danger',
					 icon: 'close',
					 position: 'top-right'
				 });
			 })
		},
		async getStages() {
			this.loading = true
			 await ContractService.getContractStage('').then(res =>{
				 this.stages = res.data
				 this.loading = false
			 }).catch(e => {
				 this.loading = false
				 this.$vs.notify({
					 title: e.message,
					 color: 'danger',
					 icon: 'close',
					 position: 'top-right'
				 });
			 })
		},
		async getEmployees() {
			this.loading = true
			 await EmployeeSerive.searchForContractManagement({page: 1, limit: 5000, value: ''}).then(res => {
				 this.employees = res.data.items
				 this.loading = false
			 }).catch(e => {
				 this.loading = false
				 this.$vs.notify({
					 title: e.message,
					 color: 'danger',
					 icon: 'close',
					 position: 'top-right'
				 });
			 })
		},
		async getCurrencys() {
			this.loading = true
			await CurrencyService.getListCurrency().then(res =>{
				this.currencys = res.data
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async getContragents() {
			this.loading = true
			 await ContrAgentService.search({page: 1, limit: 1000}).then(res =>{
				 this.contragents = res.data.items
				 this.loading = false
			 }).catch(e => {
				 this.loading = false
				 this.$vs.notify({
					 title: e.message,
					 color: 'danger',
					 icon: 'close',
					 position: 'top-right'
				 });
			 })
		},
		async getList() {
			this.loading = true
			await ContractService.getList(this.payload).then(res => {
				this.list = res.data.items
				this.total = res.data.total
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		fileSuccess(res, file) {
			this.files[this.files.length-1] = res
			this.files.push(null)
			if (res.contentType==='.jpg'||res.contentType==='.png'||res.contentType==='.svg'||res.contentType==='.jpeg')
				this.imageUrl = URL.createObjectURL(file.raw);
			this.loading = false
		},
		fileError(error) {
			this.$vs.notify({title: error.message, color: 'danger', icon: 'close', position: 'top-right'});
			this.loading = false
		},
		beforeFileUpload(file) {
			let type = null;
			if (file.name.substring((file.name.length-4), (file.name.length-5)) === '.')
				type = file.name.substring((file.name.length-4), file.name.length)
			else if (file.name.substring((file.name.length-3), (file.name.length-4)) === '.')
				type = file.name.substring((file.name.length-3), file.name.length)
			else {
				this.$vs.notify({title: 'Формат файла должен быть .pdf .doc .docx .xls .xlsx !', color: 'danger', icon: 'close', position: 'top-right'});
				return false;
			}
			if (type==='doc'||type==='docx'||type==='pdf'||type==='xls'||type==='xlsx'||type==='.doc'||type==='.docx'||type==='.pdf'||type==='.xls'||type==='.xlsx') {
				this.loading = true
			} else {
				this.$vs.notify({title: 'Формат файла должен быть .pdf .doc .docx .xls .xlsx !', color: 'danger', icon: 'close', position: 'top-right'});
				return false;
			}
			return true;
		},
		async deleteFile(file, index) {
			this.loading = true
			await ContractService.removeFile(file.id, this.form.id).then(res => {
				this.files.splice(index, 1);
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		addItem() {
			if (this.form.contractItems && this.form.contractItems.length>0) {
				let itemIndex = null,
					item = null;
				this.form.contractItems.forEach((tmp, i) => {
					if (this.item.id===tmp.id) {
						itemIndex = i
						item = tmp
					}
				})
				if (itemIndex&&item) {
					this.form.contractItems.splice(itemIndex, 1);
					this.form.contractItems.unshift(item);
				} else {
					this.form.contractItems.unshift(this.item);
				}
			} else {
				this.form.contractItems = []
				this.form.contractItems.push(this.item);
			}
			this.item = null;
			this.$refs.itemTable.refresh();
			this.form.payments = [{price: '', percentage: '', date: ''}]
		},
		deleteItem(index) {
			this.form.contractItems.splice(index, 1);
			this.item = null;
			this.$refs.itemTable.refresh();
			this.form.payments = [{price: '', percentage: '', date: ''}]
		},
		addPayment() {
			if (this.form.payments && this.form.payments.length>0) {
				this.form.payments.push({price: '', percentage: '', date: ''})
			} else {
				this.form.payments = [{price: '', percentage: '', date: ''}]
			}
			this.$forceUpdate();
		},
		deletePayment(index) {
			this.form.payments.splice(index, 1);
			this.$forceUpdate();
		},
		setPrice(value, pay, index) {
			this.form.payments[index].price = this.form.amountPriceUzs*value/100
			this.$forceUpdate();
		},
		setPercentage(value, pay, index) {
			this.form.payments[index].percentage = Math.round(100 * value / this.form.amountPriceUzs)
			this.$forceUpdate();
		},
		changeDate($event, index) {
			this.form.payments[index].date = $event
			this.$forceUpdate();
		},
		selectType($event) {
			if ($event=='1') {
				this.form.contractItems = []
			}
			this.form.amountPriceUzs = ''
			this.$forceUpdate();
		},
		viewForm(id) {
			this.$router.push(`/contract/doc/view/${id}`)
		},
		async viewHistoryDoc(id, doc) {
			this.loading = true
			this.form = doc
			await ContractService.getContractById(id).then(res => {
				this.form.contractType = res.data.contract.contractType
				this.form.amountPriceUzs = res.data.contract.amountPriceUzs
				this.form.currencyId = res.data.contract.currencyId
				this.form.payments = res.data.contract.payments
				let list = [];
				if (this.form.parentId) {
					if (res.data.parentPayments) {
						res.data.parentPayments.forEach(async (p) => {
							await ContractService.getIncomeDocsByContractId(p.id).then(inRes => {
								p.incomeDocs = inRes.data
							}).catch(e => {
								this.$vs.notify({
									title: e.message,
									color: 'danger',
									icon: 'close',
									position: 'top-right'
								});
							})
						})
						list = res.data.parentPayments
					}
				}
				this.form.parents = list
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
			await ContractService.getIncomeDocsByContractId(id).then(res => {
				this.form.incomeDocs = res.data
				this.historyModal = true
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async addPaymentForm(id) {
			this.loading = true
			await ContractService.getContractById(id).then(res => {
				this.oldForm = res.data.contract
				this.oldForm.oldPayments = res.data.parentPayments
				if (res.data.files) {
					this.files = res.data.files
				}
				this.paymentModal = true
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
			this.payment = {}
			this.payment.contractId = id
		},
		async savePayment() {
			this.loading = true
			this.payment.isPaid = true
			await ContractService.createPayment(this.payment).then(res => {
				this.$vs.notify({
					title: 'Успешно сохранено',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
				this.paymentModal = false
				this.payment = {}
				this.oldForm = null
				this.getList();
				this.getNotificationList();
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async addForm(id) {
			this.loading = true
			await ContractService.getContractById(id).then(async (res) => {
				await ContractService.createContract().then(resNew => {
					this.oldForm = res.data.contract
					this.oldForm.files = res.data.files
					this.oldForm.oldPayments = res.data.parentPayments
					let oldForm = Object.assign({}, res.data.contract)
					oldForm.parentId = res.data.contract.id
					oldForm.id = resNew.data.id
					oldForm.reason = ''
					this.form = oldForm
					this.form.amountPriceUzs = ''
					this.form.contractDate = ''
					this.form.payments = [{price: '', percentage: '', date: ''}]
					this.form.contractItems = []
					if (res.data.files) {
						this.files = res.data.files
						this.files.push(null)
					} else {
						this.files = [null]
					}
					this.create = true
					this.add = true
					this.createOrEditModal = true
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async createForm() {
			this.loading = true
			await ContractService.createContract().then(res => {
				this.create = true
				this.add = true
				this.oldForm = null
				this.getItems('');
				this.form = res.data
				this.files = [null]
				this.form.payments = [{price: '', percentage: '', date: ''}]
				this.$forceUpdate();
				this.active = 0
				this.createOrEditModal = true
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async editForm(id) {
			this.loading = true
			await ContractService.getContractById(id).then(async (res) => {
				if (res.data.contract.parentId) {
					await ContractService.getContractById(res.data.contract.parentId).then(oldRes => {
						this.oldForm = oldRes.data.contract
					}).catch(e => {
						this.oldForm = null
						this.loading = false
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				} else
					this.oldForm = null
				this.create = false
				this.add = false
				this.getItems('');
				this.form = res.data.contract
				this.$forceUpdate();
				if (res.data.files) {
					this.files = res.data.files
					this.files.push(null)
				} else {
					this.files = [null]
				}
				if (this.form.payments&&this.form.payments.length>0) {
					this.form.payments = res.data.contract.payments
					this.$forceUpdate();
				} else
					this.form.payments = [{price: '', percentage: '', date: ''}]
				this.$forceUpdate();
				this.active = 0
				this.createOrEditModal = true
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async deleteForm(id) {
			this.loading = true
			await ContractService.deleteContract(id).then(res => {
				this.getList();
				this.$vs.notify({
					title: 'Успешно удалено !',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async save(status) {
			this.loading = true
			this.form.status = status
			if (status==='READY'&&!this.verifyForm) {
				this.$vs.notify({title: 'Заполните все обязательные поля !', color: 'danger', icon: 'close', position: 'top-right'});
				return null;
			}
			if (status==='READY') {
				if (this.form.contractType&&this.form.contractType=='2') {
					if (!this.form.contractItems&&this.form.contractItems.length===0) {
						this.$vs.notify({title: 'Заполните все обязательные поля !', color: 'danger', icon: 'close', position: 'top-right'});
						return null;
					}
				} else {
					this.form.contractItems = []
				}
			}
			this.form.payments.forEach(p => {
				if (!p.isPaid)
					p.isPaid = false
			})
			await ContractService.updateContract(this.form).then(res => {
				this.form = {}
				this.create = true
				this.active = 0
				this.createOrEditModal = false
				this.getList();
				this.$vs.notify({
					title: 'Успешно удалено !',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
			this.getNotificationList();
		}
	},
	created() {
		this.getItems('');
		this.getTypes();
		this.getStages();
		this.getEmployees();
		this.getCurrencys();
		this.getContragents();
		this.getList();
	}
}
</script>

<style scoped>
.avatar-uploader {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	height: 70px;
}
.avatar-uploader:hover {
	border-color: #409EFF;
}
.avatar-uploader-icon {
	font-size: 20px;
	color: #8c939d;
	width: 300px;
	height: 70px;
	line-height: 70px;
	text-align: center;
}
.avatar {
	width: 60px;
	height: 60px;
	display: block;
}
.cursor-pointer:hover {
	cursor: pointer;
}
</style>
